import {useEffect} from "react";
import {useFormikContext} from "formik";
import {emptyFn} from "presentation/common/helpers/utils";

export const FormikEffect = ({onChange = emptyFn}) => {
  const {values} = useFormikContext();

  useEffect(() => {
    onChange(values)
  }, [values, onChange])

  return null
}
